import React, { useState } from "react";
import { InView } from "react-intersection-observer";
import PreviewCompatibleImage from "../PreviewCompatibleImage";

import volumeIncreaseChart from "../../../static/img/media/eoy2020/volume-increase.svg";
import networkIncreaseChart from "../../../static/img/media/eoy2020/network-increase.svg";
import averageAgeOverallChart from "../../../static/img/media/eoy2020/average-age-overall.svg";
import averageAgePidChart from "../../../static/img/media/eoy2020/average-age-pid.svg";
import pillRoyal from "../../../static/img/media/eoy2020/pill-royal.svg";
import pillFuchsia from "../../../static/img/media/eoy2020/pill-fuchsia.svg";
import pillViolet from "../../../static/img/media/eoy2020/pill-violet.svg";
import map from "../../../static/img/media/eoy2020/map.svg";
import pets from "../../../static/img/media/eoy2020/pets.jpg";
import teamParty1 from "../../../static/img/media/eoy2020/team-party-1.jpg";
import teamParty2 from "../../../static/img/media/eoy2020/team-party-2.jpg";

// TODO: Extract for use elsewhere (maybe its own package?)
const InViewTransition = ({
  children,
  as,
  threshold,
  className,
  inClassName,
  outClassName,
}) => {
  const [classNames, setClassNames] = useState(className);

  return (
    <InView
      threshold={threshold || 1}
      as={as || "div"}
      className={classNames}
      onChange={(inView) =>
        setClassNames(`${className} ${inView ? inClassName : outClassName}`)
      }
    >
      {children}
    </InView>
  );
};

export default ({ content, className }) => {
  return (
    <div className="space-y-12 md:space-y-16 lg:space-y-32">
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <section className="space-y-4 md:space-y-6 lg:space-y-8">
        <h2 className="font-heading-light text-2xl sm:text-3xl  md:text-4xl">
          We unveiled a new mission statement
        </h2>
        <p
          className="text-lg md:bg-violet text-violet md:text-white rounded-xl font-medium md:text-xl lg:text-2xl
          md:py-4 md:px-6 lg:py-6 lg:px-8 md:-mx-6 lg:-mx-8"
        >
          Delivering medication access opportunities through technology,
          empathy, and healthcare expertise.
        </p>
      </section>
      <section className="space-y-8 md:space-y-12">
        <h2 className="font-heading-light text-2xl sm:text-3xl md:text-4xl">
          We were able to help more patients
        </h2>

        <figure className="space-y-3">
          <figcaption className="text-royal-m1 font-medium md:text-lg lg:text-xl">
            Increased delivery volume by 170%
          </figcaption>
          <div className="-mx-1 md:-mx-2 lg:-mx-4">
            <img
              src={volumeIncreaseChart}
              alt="Bar chart showing increase in delivery volume from 2019 to 2020 of 170%"
            />
          </div>
        </figure>

        <figure className="space-y-3">
          <figcaption className="text-goldenrod-m2 font-medium md:text-lg lg:text-xl">
            Expanded our pharmacy network by 320%
          </figcaption>
          <div className="-mx-1 md:-mx-2 lg:-mx-4">
            <img
              src={networkIncreaseChart}
              alt="Bar chart showing increase in the size of our pharmacy network from 2019 to 2020 of 320%"
            />
          </div>
        </figure>

        <div className="space-y-3 pt-8">
          <h3 className="text-violet text-center font-medium md:text-lg lg:text-xl">
            Patients of all ages benefited from delivery
          </h3>

          <div className="columns lg:-mx-8 divide-navy-p2 md:divide-x-solid md:divide-x space-y-6 md:space-y-0">
            <figure className="w-full md:w-1/2 space-y-4 md:pr-8">
              <figcaption className="text-sm md:text-base font-medium text-center md:text-right text-navy md:pl-24 lg:pl-48">
                Average patient age for all deliveries
              </figcaption>

              <div className="w-3/4 sm:w-1/2 mx-auto md:w-full">
                <img
                  src={averageAgeOverallChart}
                  alt="Pie chart showing average patient age for all of our deliveres."
                />
              </div>
            </figure>

            <figure className="w-full md:w-1/2 space-y-4 md:pl-8">
              <figcaption className="text-sm md:text-base font-medium  text-center md:text-left text-navy lg:w-4/6 md:w-3/4 ">
                Average patient age for patient-initiated deliveries
              </figcaption>

              <div className="w-3/4 sm:w-1/2 mx-auto md:w-full">
                <img
                  src={averageAgePidChart}
                  alt="Pie chart showing average patient age for our patient-initiated deliveries."
                />
              </div>
            </figure>
          </div>
        </div>
      </section>
      <section className="space-y-4 md:space-y-8">
        <div className="space-y-3">
          <h2 className="font-heading-light text-2xl sm:text-3xl  md:text-4xl">
            We responded to the pandemic
          </h2>
          <p className="sm:text-lg md:text-xl md:w-2/3">
            We made a quick pivot, giving patients the power to request delivery
            from the pharmacy of their choice.
          </p>
        </div>

        <div className="columns md:-mx-12 lg:-mx-16 md:text-sm lg:text-base text-navy-p1 font-medium py-4 md:py-8 items-center">
          <div className="w-full md:w-3/12">
            <InViewTransition
              threshold={0.75}
              className="md:transition-transform duration-500 md:transform motion-reduce:transition-none motion-reduce:transform-none"
              inClassName="md:translate-y-0 md:rotate-0"
              outClassName="md:-translate-y-6 md:-rotate-12"
            >
              <img
                src={pillViolet}
                alt=""
                className="hidden md:block w-40 md:-ml-5 mb-3 max-w-none"
              />
              <h4 className="md:-mt-24 md:-ml-4 md:pt-6 leading-tight md:pl-4 md:mb-8 md:w-12 text-violet md:text-white text-lg">
                Fall 2019
              </h4>
            </InViewTransition>

            <p>ScriptDrop pilots a patient delivery solution.</p>
          </div>

          <div className="w-full md:w-4/12 md:pl-16">
            <InViewTransition
              threshold={1}
              className="md:transition-transform duration-500 delay-150 md:transform motion-reduce:transition-none motion-reduce:transform-none"
              inClassName="md:translate-y-0 md:rotate-0"
              outClassName="md:-translate-y-12 md:rotate-12"
            >
              <img
                src={pillFuchsia}
                alt=""
                className="hidden md:block  md:-mx-24 max-w-none"
              />
              <h4 className="md:-mt-24 md:-ml-4 md:pt-6 leading-tight md:pl-4 md:mb-10 text-fuchsia md:text-white text-lg">
                March 10
              </h4>
            </InViewTransition>

            <p>
              ScriptDrop revives the patient delivery technology and begins
              building out a patient-facing prescription delivery solution in
              response to the pandemic.
            </p>
          </div>
          <div className="w-full md:w-64 relative self-end">
            <div className="relative">
              <InViewTransition
                threshold={0.5}
                className="md:transition-transform duration-700 md:transform motion-reduce:transition-none motion-reduce:transform-none"
                inClassName="md:translate-x-0 md:rotate-0 scale-100"
                outClassName="md:translate-x-24 md:rotate-6 scale-75"
              >
                <img
                  src={pillRoyal}
                  alt=""
                  className="hidden md:block w-full absolute bottom-0 left-0"
                />

                <div className="md:absolute bottom-0 left-0 md:px-6 md:pb-20 lg:pb-20">
                  <h4 className="leading-tight text-royal text-lg md:text-white md:pb-1 lg:pb-2">
                    March 16
                  </h4>

                  <p className="md:text-white">
                    ScriptDrop launches the patient-initiated delivery solution.
                    From idea to reality in record time!
                  </p>
                </div>
              </InViewTransition>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <h3 className="font-medium sm:text-lg md:w-2/3">
            We were able to meet the needs of patients during the lockdown
          </h3>
          <p className="text-lg md:text-xl lg:text-2xl">
            We delivered more prescriptions in April than any other month, with
            December in a close second.
          </p>
          <p className="font-medium sm:text-lg text-fuchsia">
            As COVID-19 cases increased, we responded to the need for
            prescription delivery.
          </p>
        </div>

        <div className="py-4 md:py-8 md:-mx-4 lg:-ml-8 lg:-mr-12">
          <InViewTransition
            threshold={0.5}
            className="transition-all duration-500 transform motion-reduce:transition-none motion-reduce:transform-none"
            inClassName="scale-100 translate-x-0 filter-none"
            outClassName="translate-x-6 scale-90 filter-fade"
            as="figure"
          >
            <img
              src={map}
              alt="A map of the United States, highlighting states hit hardest by COVID-19: New York, Illinois, Texas, California, and Washington."
            />
          </InViewTransition>
        </div>
      </section>

      <section className="space-y-6 md:space-y-8">
        <h2 className="font-heading-light text-2xl sm:text-3xl md:text-4xl">
          We grew the ScriptDrop team
        </h2>

        <div className="sm:flex text-violet text-lg lg:text-xl">
          <div className="w-full sm:w-1/2 md:w-5/12 sm:flex items-center space-x-2">
            <span className="font-display text-4xl md:text-5xl lg:text-6xl">
              108
            </span>
            <span className="font-medium">teammates overall</span>
          </div>
          <div className="w-full sm:w-1/2 md:w-6/12 sm:flex items-center space-x-2">
            <span className="font-display text-4xl md:text-5xl lg:text-6xl">
              49
            </span>
            <span className="font-medium">
              full-time employees hired&nbsp;in&nbsp;2020
            </span>
          </div>
        </div>

        <p
          className="text-lg text-violet font-medium md:text-xl lg:text-2xl border-2 border-violet rounded-xl
        py-4 px-6 lg:py-6 lg:px-8 md:-mx-6 lg:-mx-8"
        >
          Our Customer Success team is still our biggest team, with 44 people.
          Our HR department is small but mighty, with one person!
        </p>
      </section>

      <section className="space-y-6 md:space-y-8 lg:space-y-12">
        <div className="space-y-3">
          <h2 className="font-heading-light text-2xl sm:text-3xl md:text-4xl">
            All while working remotely
          </h2>

          <p className="sm:text-lg md:text-xl md:w-4/5">
            Slack has been an essential mode of communication to our team. It’s
            also helped keep our workplace culture alive.
          </p>
        </div>

        <div className="columns text-lg lg:text-xl">
          <div className="w-full sm:w-1/2">
            <h3 className="font-medium">
              Most popular non-work Slack channels
            </h3>
            <p className="font-medium text-royal text-lg md:text-2xl">
              #random, #coffee
            </p>
          </div>
          <div className="w-full sm:w-1/2">
            <h3 className="font-medium">Most beloved Slack channel</h3>
            <p className="font-medium text-royal text-lg md:text-2xl">#pets</p>
          </div>
        </div>

        <div className="md:-mx-6 lg:-mx-8">
          <PreviewCompatibleImage
            imageInfo={{
              image: pets,
              alt: "A collage of some of the pets of ScriptDrop!",
            }}
          />
        </div>
      </section>

      <section className="space-y-6 md:space-y-8 lg:space-y-12">
        <div className="space-y-3">
          <h2 className="font-heading-light text-2xl sm:text-3xl md:text-4xl">
            Happy Holidays from the ScriptDrop Team
          </h2>

          <p className="sm:text-lg md:text-xl md:w-4/5">
            We look forward to helping more patients in 2021!
          </p>
        </div>

        <div className="md:-mx-6 lg:-mx-8">
          <InViewTransition
            threshold={0.5}
            className="float-left relative z-20 rounded-xl overflow-hidden transition-transform duration-1000 transform motion-reduce:transition-none motion-reduce:transform-none"
            inClassName="translate-x-0"
            outClassName="-translate-x-16"
          >
            <PreviewCompatibleImage
              imageInfo={{
                image: teamParty1,
                alt: "A collage of some of the ScriptDrop team",
              }}
            />
          </InViewTransition>

          <InViewTransition
            threshold={0.5}
            className="float-right relative mt-3 md:-mt-12 rounded-xl overflow-hidden transition-transform duration-1000 transform motion-reduce:transition-none motion-reduce:transform-none"
            inClassName="translate-x-0"
            outClassName="translate-x-16"
          >
            <PreviewCompatibleImage
              imageInfo={{
                image: teamParty2,
                alt: "Another collage of some of the ScriptDrop team",
              }}
            />
          </InViewTransition>
        </div>
      </section>
    </div>
  );
};
